import { useState } from 'react';
import { buildMeetingInfo } from '../utils/meetingInfo.js';

// One-click "Copy meeting info" button for LeadDetail / CustomerDetail.
// Composes the 3-line block via buildMeetingInfo() and writes it to the
// clipboard. Shows a 1.5s success state ("Copied!") so the user has
// visible feedback that it worked. Falls back to a textarea + execCommand
// for older browsers / non-HTTPS contexts where navigator.clipboard
// isn't available.
export default function CopyMeetingInfoButton({ record, user, className = '' }) {
  const [copied, setCopied] = useState(false);
  const [err, setErr] = useState(null);

  async function handleClick() {
    const text = buildMeetingInfo(record, user);
    if (!text) { setErr('Nothing to copy'); setTimeout(() => setErr(null), 1500); return; }
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        // Legacy fallback. document.execCommand is deprecated but still
        // works on insecure-origin/older browsers.
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error('Copy meeting info failed:', e);
      setErr('Copy failed');
      setTimeout(() => setErr(null), 2000);
    }
  }

  const label = err ? err : (copied ? 'Copied!' : 'Copy meeting info');
  return (
    <button
      type="button"
      className={`btn-secondary ${className}`.trim()}
      onClick={handleClick}
      title="Copy a 3-line meeting summary (site / contact / host) to the clipboard"
    >
      {label}
    </button>
  );
}
